export const useHover = (_props, _ref) => {
  let params = {
    hoverProps: {},
    isHovered: false
  };
  return params;
};
//# sourceMappingURL=useHover.js.map